import React from "react";
import { Link } from "react-router-dom";
import { headerView } from "./headerModel.mjs";

/*
 * THE SLIM STICKY LINE, once the header has scrolled away (frame 1i, "Sticky
 * header once you scroll"): name · position pill · Open full page · ×.
 *
 * The full header may wrap to five lines; once it is gone the record still has
 * to say whose it is and where they stand, and the way out has to stay in reach.
 * The shell decides when it shows (an IntersectionObserver on the header against
 * the host's own scroll root, since Today, Leads and Approvals each scroll their
 * panel, not the window) and lays it over the content in a zero-height sticky
 * wrapper, so its arrival never pushes the record down by its own height.
 *
 * The pill is the header's own (headerModel.mjs), small. A click brings the
 * header back into view and opens Change status… under the real pill, rather
 * than opening a second menu up here. On the phone the record has its own top
 * bar with the way back and ×, so this line carries only the name and the pill.
 *
 * Props:
 *   record    the shell's bundle: contact, company, view.position, layout, ui.status
 *   ops       ops.closeStatus, ops.openStatus({ scroll: true })
 *   onClose   () => void | null, the panel's ×; null on the full page
 *   fullHref  string | null, "Open full page" (embedded only)
 *   onOpenFull (event) => void | null, the shell's guard on that link: an edited
 *             draft asks before the panel goes
 */
export default function StickyLine({ record, ops, onClose = null, fullHref = null, onOpenFull = null }) {
  const h = headerView(record);
  const phone = record.layout === "phone";
  return (
    <div className="rec-sticky">
      <span className="rec-sticky__name">{h.name}</span>
      {h.pill && (
        <button
          type="button"
          className={h.pill.smallClassName}
          title="Change status…"
          aria-haspopup="menu"
          // openStatus toggles; from up here the intent is always "open", so a
          // menu already open under the header is closed first and opened again
          // (both are functional updates, applied in order).
          onClick={() => {
            ops.closeStatus();
            ops.openStatus({ scroll: true });
          }}
        >
          {h.pill.text} ▾
        </button>
      )}
      <span className="rec-sticky__spacer" />
      {!phone && fullHref && (
        <Link className="rec-sticky__open" to={fullHref} onClick={onOpenFull || undefined}>
          Open full page
        </Link>
      )}
      {!phone && onClose && (
        <button type="button" className="rec-close" title="Close (Esc)" aria-label="Close panel" onClick={onClose}>
          ×
        </button>
      )}
    </div>
  );
}
